/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreGraphLow = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M.816 5.804a.5.5 0 0 0-.316.465v8.5a.5.5 0 0 0 .5.5h13.5c.276 0 .5-.224.5-.5s-.306-.476-1.473-1.689c-1.189-1.235-2.779-2.977-2.779-2.977a.498.498 0 0 0-.656-.079l-2.964 2.031-5.764-6.129a.503.503 0 0 0-.548-.122zM15.5 9.769v-2.5a.5.5 0 0 0-1 0v1.293l-3.646-3.647a.498.498 0 0 0-.631-.062L7.564 6.625 1.815.877a.5.5 0 0 0-.707.707l6.039 6.039a.5.5 0 0 0 .63.062l2.659-1.772 3.357 3.356H12.5a.5.5 0 0 0 0 1H15a.5.5 0 0 0 .5-.5z"
    />
  </svg>
);

IconCoreGraphLow.displayName = 'IconCoreGraphLow';

IconCoreGraphLow.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreGraphLow);
IconCoreGraphLow.displayName = 'IconCoreGraphLow';
